import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {injectIntl} from "react-intl";
import __i18n from "../../../../../intl/__i18n";
import {getFormattedDate, showDate} from "../../../../../utils";

function NewUsersChart({data, intl}) {
  const {formatMessage} = intl;
  
  return(
    <div className={'chart-wrapper'}>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            type: 'column',
            height:250,
          },
          title: {
            text: __i18n("New Users")
          },
          xAxis: {
            type: 'category',
            labels: {
              formatter: function () {
                return getFormattedDate({date : this.value, showTime: false})
              }
            }
          },
          yAxis: {
            min: 0,
            title: {
              text: __i18n("Count")
            }
          },
          legend: {
            enabled: false
          },
          tooltip: {
            enabled: false
          },
          series: [{
            name:__i18n("New Users"),
            data: data.map(item => ([ item.date_time, item.total ])),
            dataLabels: {
              enabled: true,
              rotation: -90,
              color: '#FFFFFF',
              align: 'right',
              // format: '{point.y:.1f}', // one decimal
              y: 10, // 10 pixels down from the top
              style: {
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif'
              }
            }
          }]
        }}
      />
    </div>
  )
}

export default injectIntl(NewUsersChart);

